module.exports = __webpack_public_path__ + "static/Slashdot-4c9945e45179eeb0bcec523ebfd6f94f.png";